import { render, staticRenderFns } from "./Index-弹出框格式.vue?vue&type=template&id=3601d4b2&scoped=true&"
import script from "./Index-弹出框格式.vue?vue&type=script&lang=js&"
export * from "./Index-弹出框格式.vue?vue&type=script&lang=js&"
import style0 from "./Index-弹出框格式.vue?vue&type=style&index=0&id=3601d4b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3601d4b2",
  null
  
)

export default component.exports